import * as R from 'ramda'

// inserts hyphens between groups of 3 characters
const formatMatcher = /([a-zA-Z0-9]{3})(?=[a-zA-Z0-9]{3})/g
const formatReplacer = '$&-'

export const formatMeetingCode = meetingCode =>
  (meetingCode || '').replace(formatMatcher, formatReplacer)

const toString = x => x && x.toString()

/**
 * Reads a Twilio participant identity and names it from the meeting: the
 * meeting's client, its coach, or whoever the identity says. Works from
 * clientSummary and the meeting's coach when the viewer may not read the
 * client record.
 */
export const parseIdentity = (meeting, json) => {
  if (!json) return {}
  try {
    const parsed = JSON.parse(json)
    const identity = R.evolve(
      {
        clientId: toString,
        coachId: toString,
        userId: toString,
        rid: toString,
      },
      parsed
    )

    const { clientId, coachId, name } = identity
    // client is null for a visitor who may not read the client's record (the
    // signed-out client among them); clientSummary and the meeting's coach
    // still name the two sides.
    const { client, clientSummary, coach } = meeting
    const meetingClientId = toString(client?.id ?? clientSummary?.id)
    const meetingCoach = client?.coach ?? coach

    const isMeetingClient = clientId && clientId === meetingClientId
    const isMeetingCoach = coachId && coachId === toString(meetingCoach?.id)

    return {
      ...identity,
      isMeetingClient,
      isMeetingCoach,
      isAClient: !!clientId,
      isACoach: !!coachId,
      name: isMeetingClient
        ? client?.user?.firstName ?? clientSummary?.firstName
        : isMeetingCoach
        ? meetingCoach?.user?.firstName
        : name || 'Anonymous User',
    }
  } catch {
    return {}
  }
}
